<template>
  <section class="gallary_head">
    <div>
      <div class="cover_img">
        <img src="../../assets/img/gallary.jpg" />
        <h2>Gallery</h2>
      </div>
      <section class="gallary" id="show-on-scroll">
        <div class="container">
          <div class="gallary_body">
            <div
              class="image_hover"
              data-aos="zoom-in"
              @click="showImage()"
              v-for="(img, index) in imgs"
              :key="index"
            >
              <figure><img :src="img.src" alt="" /></figure>
            </div>
            <!-- <div class="image_hover" data-aos="zoom-in" @click="showImage()">
              <figure><img src="../../assets/img/20.png" alt="" /></figure>
            </div>
            <div class="image_hover" data-aos="zoom-in" @click="showImage()">
              <figure><img src="../../assets/img/21.png" alt="" /></figure>
            </div>
            <div class="image_hover" data-aos="zoom-in" @click="showImage()">
              <figure><img src="../../assets/img/29.png" alt="" /></figure>
            </div>
            <div class="image_hover" data-aos="zoom-in" @click="showImage()">
              <figure><img src="../../assets/img/23.png" alt="" /></figure>
            </div>
            <div class="image_hover" data-aos="zoom-in" @click="showImage()">
              <figure><img src="../../assets/img/24.png" alt="" /></figure>
            </div>
            <div class="image_hover" data-aos="zoom-in" @click="showImage()">
              <figure><img src="../../assets/img/25.png" alt="" /></figure>
            </div>
            <div class="image_hover" data-aos="zoom-in" @click="showImage()">
              <figure><img src="../../assets/img/26.png" alt="" /></figure>
            </div>
            <div class="image_hover" data-aos="zoom-in" @click="showImage()">
              <figure><img src="../../assets/img/27.png" alt="" /></figure>
            </div>
            <div class="image_hover" data-aos="zoom-in" @click="showImage()">
              <figure><img src="../../assets/img/28.png" alt="" /></figure>
            </div>
            <div class="image_hover" data-aos="zoom-in" @click="showImage()">
              <figure><img src="../../assets/img/29.png" alt="" /></figure>
            </div> -->
           
          </div>
        </div>
      </section>
      <section class="gallary_open">
        <transition name="fade" appear>
          <div class="modal-overlay" v-if="open"></div>
        </transition>
        <transition data-aos="zoom-in" v-for="(img, index) in imgs" :key="index">
          <div class="modal" v-if="open">
            <span class="button" @click="open = false" name="fade" mode="out-in">
              <i class="fas fa-times share-close"></i>
            </span>
            <img :src="img.src" alt="" />
            <div class="change_bottun">
              <button class="button" @click="next++">
                <i class="fas fa-arrow-right arrow"></i>
              </button>
              <button class="button left" @click="index--">
                <i class="fas fa-arrow-left arrow"></i>
              </button>
            </div>
          </div>
        </transition>
      </section>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      open: false,
      imgs: [
        {
          // src: "img/20.png",
          src: require('../../assets/img/20.png'),
        },
        {
          src: require('../../assets/img/21.png'),
        },
        {
          src:require('../../assets/img/29.png'),
        },
        {
          src: require('../../assets/img/23.png'),
        },
        {
          src: require('../../assets/img/24.png'),
        },
        {
          src: require('../../assets/img/25.png'),
        },
        {
          src: require('../../assets/img/26.png'),
        },
        {
          src: require('../../assets/img/27.png'),
        },
        {
          src: require('../../assets/img/28.png'),
        },
      ],
    };
  },
  mounted() {},
  methods: {
    showImage() {
      this.open = !this.open;
    },
  },
};
</script>
<style scoped></style>
